import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

export interface CreateReferralByPatientIdRequest {
  practiceId: string;
  unifiedAppointmentId?: string;
  pmsPatientVideaId?: string;
  imagingPatientVideaId?: string;
  patientFirstName?: string;
  patientLastName?: string;
  patientEmail?: string;
  patientPhone?: string;
  patientDateOfBirth?: string;
  estimatedVisitId?: number;
  analysisIds?: string[];
  referralReason?: string;
  narrative?: string;
  toothNumbers?: string[];
  imageUrls?: string[];
  specialtyId?: number;
  proceduresIds?: number[];
  referralPracticeId?: number;
  referralSpecialistId?: number;
  useNextAvailableSpecialist?: boolean;
  practiceEmail?: string;
  doctorFirstName?: string;
  doctorLastName?: string;
  doctorPhone?: string;
  status?: 'not_started' | 'needs_referral' | 'in_progress' | 'submitted';
}

export const useCreateReferralByPatientId = (
  options?: UseMutationOptions<
    { id: string },
    unknown,
    CreateReferralByPatientIdRequest
  >,
) => {
  const { primaryOrganizationId: orgId } = useSelector(
    (state: any) => state.login.user,
  );

  return useMutation<{ id: string }, unknown, CreateReferralByPatientIdRequest>(
    (data) =>
      makeAPIRequestReactQuery<{ id: string }>(
        endpoints.referrals + '/v2',
        undefined,
        'post',
        {
          headers: {
            Org: orgId,
            'Content-Type': 'application/json',
          },
          data,
        },
      ),
    options,
  );
};
